
import request from '@/utils/server'
 
//  排菜获取菜品列表
export function getDishList(query) {
    return request({
      url: '/dish/getDishList',
      method: 'get',
      params: query
    })
  }
// 保存排菜
export function dishArrangement(data){
     return request({
      url: '/dish/dishArrangement',
      method: 'POST',
     data:data
    })
}
// 获取排菜

export function getDishArrangementList(query) {
    return request({
      url: '/dish/getDishArrangementList',
      method: 'get',
      params: query
    })
  }
  // 生成订单
  export function getDishByDate(query) {
    return request({
      url: '/dish/getDishByDate',
      method: 'get',
      params: query
    })
  }